import image1 from '@/main/assets/images/homepage/shutterstock_2294415235.jpg';
import image2 from '@/main/assets/images/homepage/shutterstock_2337070637.jpg';
import image3 from '@/main/assets/images/homepage/shutterstock_557229235.jpg';
import image4 from '@/main/assets/images/homepage/Mask group-1.png';
import image5 from '@/main/assets/images/homepage/shutterstock_2294492899.jpg';
import image6 from '@/main/assets/images/homepage/asset@3x.png'

import * as S from './styles';
import TextImage from '../components/textImage/textImage';
import { getTranslateByKey } from '@/main/services/utils';

function HomepageBodyshopScreen() {
  return (
    <S.Container>
      <S.FirstSection>
        <TextImage
          isWithPadding={false}
          backgroundImage={image1}
          idImage="id-homepage-bodyshop-image-1"
          title={getTranslateByKey('information.homepageBodyshop1')}
          description=""
          positionImage="right"
          imageProps={{
            clipBorderImage: 'bottom',
            width: '410px',
            height: '532px'
          }}
          showButton={true}
          subTitle={getTranslateByKey('information.forBodyshops')}
        />
      </S.FirstSection>
      <S.ImageLine src={image6} data-aos='fade-up' />
      <TextImage
        backgroundImage={image2}
        idImage="id-homepage-bodyshop-image-2"
        title={getTranslateByKey('information.homepageBodyshop2')}
        description={getTranslateByKey('information.homepageBodyshop3')}
        positionImage="left"
        imageProps={{
          clipBorderImage: 'right',
          width: '530px',
          height: '340px'
        }}
      />
      <TextImage
        backgroundImage={image3}
        idImage="id-homepage-bodyshop-image-3"
        title={getTranslateByKey('information.homepageBodyshop4')}
        description={getTranslateByKey('information.homepageBodyshop5')}
        positionImage="right"
        imageProps={{
          clipBorderImage: 'left',
          width: '530px',
          height: '340px'
        }}
      />
      <TextImage
        backgroundImage={image4}
        idImage="id-homepage-bodyshop-image-4"
        title={getTranslateByKey('information.homepageBodyshop6')}
        description={getTranslateByKey('information.homepageBodyshop7')}
        positionImage="left"
        imageProps={{
          clipBorderImage: 'right',
          width: '530px',
          height: '340px'
        }}
      />
      <TextImage
        backgroundImage={image5}
        idImage="id-homepage-bodyshop-image-5"
        title={getTranslateByKey('information.homepageBodyshop8')}
        description={getTranslateByKey('information.homepageBodyshop9')}
        positionImage="right"
        imageProps={{
          clipBorderImage: 'right',
          width: '530px',
          height: '340px'
        }}
      />
    </S.Container>
  );
}

export default HomepageBodyshopScreen;
